import { IEmojiProps } from "interfaces";
import { getEmojiUrl } from "../../../../../services";

const Emoji = ({ name, className, dataMarker }: IEmojiProps) => {
    return <img data-marker={dataMarker} src={`${getEmojiUrl()}/${name}.png`} alt={name} className={className} />;
};

export default Emoji;
